document.addEventListener('DOMContentLoaded', () => {
    const icons = document.querySelectorAll('.bg-icon-plus');
    const speed = 0.4;
    
    // Use intersection observer to detect when the icons are in the viewport
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const icon = entry.target;
                
                // Apply parallax effect when the icon is in the viewport
                window.addEventListener('scroll', () => updateParallax(icon));
                updateParallax(icon);
            }
        });
    }, {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    });

    function updateParallax(icon) {
        const scrollY = window.scrollY;
        const iconRect = icon.getBoundingClientRect();
        const iconPosition = scrollY + iconRect.top;
        const viewportHeight = window.innerHeight;
        
        const progress = Math.max(0, Math.min(1, (scrollY - iconPosition + viewportHeight) / (viewportHeight + iconRect.height)));
        const offsetY = progress * speed * -100;
        
        icon.style.transform = `translateY(${offsetY}px)`;
    }

    // Observe each icon
    icons.forEach(icon => observer.observe(icon));
});